import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { LeftNavLayout } from 'containers';
import { getAffiliatePartners } from 'redux/modules/partners';
import { archiveProduct, addProduct, getProducts, saveProduct } from 'redux/modules/products';
import { EmptyState, PageHeader, Spinner } from 'components';
import ProductAccordion from './ProductAccordion';
import { connect } from 'react-redux';
import * as styles from './PackageManager.scss';
var PackageManager = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    gettingProducts: state.products.gettingProducts,
    productsByOrgId: state.products.productsByOrgId,
    affiliatePartners: state.partners.affiliatePartners,
    theme: state.theme
  };
}, {
  archiveProduct: archiveProduct,
  addProduct: addProduct,
  getAffiliatePartners: getAffiliatePartners,
  getProducts: getProducts,
  saveProduct: saveProduct
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(PackageManager, _Component);

  var _super = _createSuper(PackageManager);

  function PackageManager() {
    var _this;

    _classCallCheck(this, PackageManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handlePartnerSelected", function (event, index, value) {
      browserHistory.push("/global/package-manager/".concat(value));
    });

    return _this;
  }

  _createClass(PackageManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.affiliatePartners.length) {
        this.props.getAffiliatePartners();
      }

      if (this.props.params.orgId) {
        this.props.getProducts(this.props.params.orgId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin"
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Package Manager"
      }), /*#__PURE__*/React.createElement("div", {
        id: "PackageManager"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Admin",
        secondary: "Package Manager",
        style: {
          borderBottom: '1px solid #f1f1f1',
          paddingBottom: 16,
          marginBottom: 0,
          marginTop: 16
        }
      }), !this.props.params.orgId && /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 36
        }
      }, "Select a partner to see their product packages."), !!this.props.affiliatePartners.length && /*#__PURE__*/React.createElement(SelectField, {
        floatingLabelText: "Affiliate Partners",
        value: this.props.params.orgId,
        onChange: this.handlePartnerSelected
      }, this.props.affiliatePartners.map(function (partner) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: partner.id,
          value: partner.id,
          primaryText: partner.name
        });
      })), this.props.gettingProducts && !this.props.productsByOrgId[this.props.params.orgId] && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        style: {
          marginLeft: 100
        }
      })), this.props.productsByOrgId[this.props.params.orgId] && /*#__PURE__*/React.createElement(ProductAccordion, {
        emptyState: /*#__PURE__*/React.createElement("div", {
          style: {
            padding: 8
          }
        }, "No Packages"),
        products: this.props.productsByOrgId[this.props.params.orgId],
        handleAddProduct: this.props.addProduct,
        handleArchiveProduct: this.props.archiveProduct,
        handleSaveProduct: function handleSaveProduct(product) {
          _this2.props.saveProduct(product, _this2.props.params.orgId);
        },
        selectedOrgId: this.props.params.orgId
      })));
    }
  }]);

  return PackageManager;
}(Component), _defineProperty(_class2, "defaultProps", {}), _temp)) || _class);
export { PackageManager as default };